import { FC } from 'react'
import { useRouteError, isRouteErrorResponse } from 'react-router-dom'

interface RouteError {
    statusText?: string
    message?: string
}

export const RouteError: FC = () => {
    const error = useRouteError()

    let errorMessage = 'Unknown error'

    if (isRouteErrorResponse(error)) {
        errorMessage = error.statusText || error.data?.message || 'Route error'
    } else if (error instanceof Error) {
        errorMessage = error.message
    } else if (typeof error === 'object' && error !== null) {
        const routeError = error as RouteError
        errorMessage =
            routeError.statusText || routeError.message || 'Unknown error'
    }

    console.error(error)

    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>Sorry, an expected error has occurred.</p>
            <p>
                <i>{errorMessage}</i>
            </p>
        </div>
    )
}
